export default __webpack_public_path__ + "static/media/avatar.562f09a9.svg";